import React from 'react';
import camera from '../../assets/images/camera.svg'
import Cropper from 'react-easy-crop'
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';

export default function ImageUpload({
  iconFontSize=60,
  onChange,
  previewChange,
  previewImage = false,
  remove = false,
  onCropComplete = false,
  buttomText = 'Selecionar áudio',
}) {
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [zoom, setZoom] = React.useState(1);
  const [aspect, setAspect] = React.useState(4 / 3);

  const onCropChange = crop => {
    setCrop(crop)
  }

  const onCropCompleteFn = (croppedArea, croppedAreaPixels) => {
    if (typeof onCropComplete === 'function') {
      onCropComplete(croppedArea, croppedAreaPixels)
    }
  }

  const onZoomChange = zoom => {
    setZoom(zoom)
  }

  return (
    <>
      <div style={{ display: !previewChange ? 'block' : 'none' }}>
        <label id="thumbnail" style={{
          borderStyle: 'dotted',
          borderWidth: 3,
          borderColor: '#e0e0e0',
          display: 'flex',
          width: 170,
          height: 90 / aspect,
          backgroundSize: 'cover',
          backgroundImage: previewChange ? `url(${previewChange})` : `url(${previewImage})`,
          cursor: 'pointer',
        }}>
          <input type="file" style={{
            display: 'none'
          }}
            onChange={onChange}
          />
          <AudiotrackIcon  style={{ fontSize: iconFontSize }} />
          <h4>{buttomText}</h4>
          {/* <img
            src={AudiotrackIcon}
            alt="Selecionar imagem"
            style={{
              display: previewChange || previewImage ? 'none' : 'flex',
              flex: 1,
              padding: 45,
            }}
          /> */}
        </label>
        {previewImage.length > 0 &&
          <IconButton aria-label="delete" color="secondary"
            aria-label="remover foto"
            onClick={() => {
              if (typeof remove === 'function') {
                remove(true)
              }
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        }
      </div>
      {previewChange &&
        <>
          <div style={{
            position: 'relative',
            height: 300,
            width: 300,
            backgroundColor: '#333'
          }}>
            <Cropper
              image={previewChange ? previewChange : previewImage}
              crop={crop}
              zoom={zoom}
              aspect={aspect}
              onCropChange={onCropChange}
              onCropComplete={onCropCompleteFn}
              onZoomChange={onZoomChange}
            />
          </div>
          <IconButton aria-label="delete" color="secondary"
            aria-label="remover foto"
            onClick={() => {
              if (typeof remove === 'function') {
                remove()
              }
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </>
      }
    </>
  );
}